import React from "react";
import { Switch, Route } from "react-router-dom";
import "./OrderDispatching.scss";
import OrderDispatchingPage from "./OrderDispatchingPage";
import DriverBookingHistoryPage from "./DriverBookingHistoryPage";

const OrderDispatching = () => (
  <Switch>
    <Route path="/dispatch/order-dispatching">
      <OrderDispatchingPage />
    </Route>
    <Route path="/dispatch/driver-bookings/:id">
      <DriverBookingHistoryPage />
    </Route>
  </Switch>
);

export default OrderDispatching;
